import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";


const BASE_URL = typeof window !== 'undefined' ? window.serverData.data.phyndApibaseUrl : ''; // window is undefined during pre-render
const CLIENT_ID = "MyBSWHealth.Web";


/**
 * Phynd v2 SearchForAllProviders.
 * 
 * @param {any} searchModel Search parameters; property names must match the phynd api.
 * @returns {Promise} provider search results.
 */
export const searchForAllProviders = (searchModel, isLatestCall = false) => {
    const queryString = [];
    for (var property in searchModel) {
        if (searchModel[property] !== "") {
            queryString.push(`${property}=${encodeURIComponent(searchModel[property])}`);
        }
    }

    const fullUrl = isLatestCall ? 
    `${BASE_URL}V3/Provider/SearchForAllProviders?${queryString.length > 0 ? queryString.join("&") : ""}` : 
    `${BASE_URL}V2/Provider/SearchForAllProviders?${queryString.length > 0 ? queryString.join("&") : ""}`;
    
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    var start = new Date();
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Provider.Search", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Provider.Search.Failure", start, url, err); return Promise.reject(err); });
};

export const getProvidersListByVisitType = (searchModel, token) => {
    const start = new Date();
    const fullUrl = `${BASE_URL}V2/Scheduling/GetProvidersListByVisitType?patientId=${(searchModel.proxyPatientId)}&loginId=${(searchModel.loginId)}&visitTypeId=${(searchModel.visitTypeId)}&patientIdType=${(searchModel.proxyPatientIdType)}`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "Authorization": `bearer ${token}`
        },
        method: "GET"
    };

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Schedule.Direct.ProvidersListByVisitType.Get", start, fullUrl);
            return response.json();
        })
        .catch(error => {
            logAPI("MBHWeb.Api.Schedule.Direct.ProvidersListByVisitType.Get.Failure", start, fullUrl, JSON.stringify(error));
            return Promise.reject(error);
        });
};

/**
 * Phynd v2 SearchForAllProvidersByName.
 * 
 * @param {any} searchModel Search parameters; property names must match the phynd api.
 * @returns {Promise} provider search results.
 */
export const searchForAllProvidersByName = (searchModel) => {

    const fullUrl = encodeURI(`${BASE_URL}V2/Provider/SearchForAllProvidersByName?name=${searchModel.name}&networkCode=${searchModel.networkCode}`);
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Search.Provider.ByName", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Search.Provider.ByName.Failure", start, fullUrl, err); return Promise.reject(err); });
};


/**
 * Phynd v2 GetProviderDetail.
 * 
 * @param {any} searchModel Search parameters; property names must match the phynd api.
 * @returns {Promise} provider detail model.
 */
export const getProviderDetail = (searchModel) => {
    const ids = typeof searchModel.ids === "string" ? searchModel.ids : searchModel.ids.join("|");
    let fullUrl = encodeURI(`${BASE_URL}V2/Provider/GetProviderDetail?Ids=${ids}&IdType=${searchModel.idType ? searchModel.idType : 'NPI'}`);
    if (searchModel.networkCode) {
        fullUrl += `&networkCode=${searchModel.networkCode}`;
    }
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Provider.Detail.Default", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Provider.Detail.Default.Failure", start, fullUrl, err); return Promise.reject(err); });
};


/**
 * Phynd v2 SearchForAllProvidersByLocationAndDistance.
 * 
 * @param {any} searchModel Search parameters; property names must match the phynd api.
 * @returns {Promise} provider search results.
 */
export const searchForAllProvidersByLocationAndDistance = (searchModel) => {

    const fullUrl = encodeURI(`${BASE_URL}V2/Provider/SearchForAllProvidersByLocationAndDistance?location=${searchModel.location}&distance=${searchModel.distance}&pageNumber=${searchModel.pageNumber}&perPage=${searchModel.perPage}`);
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    var start = new Date();
    //const request = new Request(fullUrl, params);
    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Search.Provider.ByLocationDistance", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Search.Provider.ByLocationDistance.Failure", start, fullUrl, err); return Promise.reject(err); });
};



/**
 * Phynd v1 GetProviderDetail.
 * 
 * @param {string} token  = current user token
 * @param {string} NPIs = pipe delimited list of provider NPIs
 * @param {string} NetworkCode = current user's health plan network code (if applicable)
 * @param {boolean} LiteObject = return lite object or not
 * @returns {Promise} provider search results.
 */
export const getProviderDetailV1 = (token, NPIs, NetworkCode, LiteObject) => {

    const fullUrl = encodeURI(`${BASE_URL}V1/Provider/GetProviderDetail?Ids=${NPIs}&IdType=NPI&networkCode=${NetworkCode}&ReturnLiteObject=${LiteObject}`);
    const headers = {
        "x-bsw-clientid": CLIENT_ID,
    };
    const start = new Date();

    return fetch2(fullUrl, token, null, 'get', headers).then(response => {
        logAPI("MBHWeb.Api.Provider.Detail.Default", start, fullUrl);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Provider.Detail.Default.Failure", start, fullUrl, err); return Promise.reject(err); });

};


/**
 * Phynd v2 GetProviderDetailLite.
 * 
 * @param {string} token  = current user token
 * @param {string} NPIs = pipe delimited list of provider NPIs
 * @param {string} NetworkCode = current user's health plan network code (if applicable)
 * @param {boolean} LiteObject = return lite object or not
 * @returns {Promise} provider search results.
 */
export const getProviderDetailLiteV2 = (token, NPIs, NetworkCode, LiteObject) => {

    const fullUrl = encodeURI(`${BASE_URL}V2/Provider/GetProviderDetailLite?Ids=${NPIs}&IdType=NPI&networkCode=${NetworkCode}&ReturnLiteObject=${LiteObject}`);
    const headers = {
        "x-bsw-clientid": CLIENT_ID,
    };
    const start = new Date();

    return fetch2(fullUrl, token, null, 'get', headers).then(response => {
        logAPI("MBHWeb.Api.Provider.Detail.Default", start, fullUrl);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Provider.Detail.Default.Failure", start, fullUrl, err); return Promise.reject(err); });

};


export const getNpiFromLoginId = (loginId) => {
    const fullUrl = `${BASE_URL}V2/Provider/GetProviderDetail?Ids=${encodeURIComponent(loginId)}&IdType=LoginId`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };

    const start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Provider.Detail.Default", start, fullUrl);
            return response.json();
        })
        .then(resp => {
            let npi = resp.length > 0 ? resp[0].npi : null;
            return Promise.resolve(npi);
        })
        .catch(err => { logAPI("MBHWeb.Api.Provider.Detail.Default.Failure", start, fullUrl, err); return Promise.reject(err); });
};

/**
 * Phynd v3 MyDoctorDirectVideoVisitSchedules.
 *
 * @param {any} searchModel Search parameters; property names must match the phynd api.
 * @returns {Promise} provider search results.
 */
export const getMyDoctorDirectVideoVisitSchedules = (searchModel, token) => {
    const fullUrl = `${BASE_URL}V3/Scheduling/GetMyDoctorDirectVideoVisitSchedules?patientId=${(searchModel.proxyPatientId)}&loginId=${(searchModel.loginId)}`;
    var start = new Date();
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "authorization": "bearer " + token,
        },
        method: "GET"
    };

    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Provider.GetMyDoctorDirectVideoVisitSchedules", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Provider.GetMyDoctorDirectVideoVisitSchedules.Failure", start, fullUrl, err); return Promise.reject(err); });
};

export const getProviderWithEarliestSchedule = (searchModel) => {

    const queryString = [];
    for (var property in searchModel) {
        if (searchModel[property] !== "") {
            queryString.push(`${property}=${encodeURIComponent(searchModel[property])}`);
        }
    }

    const fullUrl = `${BASE_URL}V2/Scheduling/GetProviderWithEarliestSchedule?${queryString.length > 0 ? queryString.join("&") : ""}`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    var start = new Date();

    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Provider.GetEarliestSchedule", start, fullUrl);
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Provider.GetEarliestSchedule.Failure", start, fullUrl, err); return Promise.reject(err); });
};

export const searchForGenericProvider = (token, location, radius, sortBy = 'NextAvailableAppointment', visitTypeId, page, perPage, startDate = null, endDate = null) => {
    let fullUrl = `${BASE_URL}V3/Scheduling/SearchForGenericProvider?location=${location}&radius=${radius}&sortBy=${sortBy}&visitTypeId=${visitTypeId}&page=${page}&perPage=${perPage}`;

    if (startDate && endDate) {
        fullUrl += `&startDate=${startDate}&endDate=${endDate}`;
    }

    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "authorization": `bearer ${token}`
        },
        method: "GET"
    };

    const start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Provider.SearchForGenericProvider.Success", start, fullUrl);
            return response.json();
        }).catch(err => { logAPI("MBHWeb.Api.Provider.SearchForGenericProvider.Failure", start, fullUrl, err); return Promise.reject(err); });
};